<template>
  <Drawer
    width="500"
    :title="`${openedDuizhangdan ? '编辑' : '新增'}-对账单`"
    v-model="drawerOpened"
  >
  <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem
          label="客户"
          prop="customer"
        >
          <Select
            v-model="formItem.customer"
            filterable
            :disabled="openedDuizhangdan ? true : false"
            remote
            :remote-method="remoteMethod"
            :loading="customerLoading"
            placeholder="请填写客户名字后选择"
          >
            <Option
              v-for="option in customersSimple"
              :value="option._id"
              :key="option._id"
            >{{ option.name }}</Option>
          </Select>
        </FormItem>
        
        <FormItem
          label="合同签署公司"
          prop="company"
        >
          <Select
            v-model="formItem.company"
            filterable
            clearable
          >
            <Option
              v-for="option in companyList"
              :value="option._id"
              :key="option._id"
            >{{ option.abbr }}</Option>
          </Select>
        </FormItem>

        <FormItem
          label="开始日期"
          prop="startDate"
        >
          <DatePicker
            style="width: 200px"
            type="date"
            v-model="formItem.startDate"
            placeholder="选择开始日期"
          ></DatePicker>
        </FormItem>

        <FormItem
          label="结束日期"
          prop="endDate"
        >
          <DatePicker
            style="width: 200px"
            type="date"
            v-model="formItem.endDate"
            placeholder="选择结束日期"
          ></DatePicker>
        </FormItem>

        
        <FormItem
          label="欠款金额（元）"
          prop="debtAmount"
        >
          <InputNumber
            style="width: 200px"
            v-model="formItem.debtAmount"
          ></InputNumber>
        </FormItem>

        <FormItem label="备注" prop="remark">
        <Input
          v-model="formItem.remark"
          placeholder="输入备注..."
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        />
      </FormItem>
  
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
          >保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { createDuizhangdan } from "@/api/duizhangdan";
import receive from "@/store/modules/receive";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "EditFactoryDrawer",
  components: {},
  data() {
    return {
      drawerOpened: false,
      openedDuizhangdan: null,
      customerLoading: false,
      formItem: {
        customer: null,
        company: null,
        startDate: null,
        endDate: null,
        debtAmount: null,
        remark: null,
      },
      ruleValidate: {
        customer: [{ required: true, message: "必填项", trigger: "submit" }],
        company: [{ required: true, message: "必填项", trigger: "submit" }],
      },
    };
  },
  computed: {
    ...mapState({
      customersSimple: (state) => state.customer.customersSimple,
      companyList: (state) => state.company.companyList,
    }),
    ...mapGetters({
      
    }),
  },
  methods: {
    ...mapActions({
      createDuizhangdan: "duizhangdan/createDuizhangdanAction",
      updateDuizhangdan: "duizhangdan/updateDuizhangdanAction",
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
    }),
    async openDrawer(duizhangdan) {
      this.$refs["formItem"].resetFields();
      this.openedDuizhangdan = duizhangdan; // 如果有打开，则为编辑模式
      this.drawerOpened = true;
      if (duizhangdan) {
        await this.getCustomerSimpleList({ name: duizhangdan.customer.name });
        this.formItem.customer = duizhangdan.customer._id;
        this.formItem.company = duizhangdan.company._id;
        this.formItem.startDate = duizhangdan.startDate;
        this.formItem.endDate = duizhangdan.endDate;
        this.formItem.debtAmount = duizhangdan.debtAmount;
        this.formItem.remark = duizhangdan.remark;
      }
    },
    async remoteMethod(query) {
      if (query !== "" && !this.openedDuizhangdan) {
        this.customerLoading = true;
        await this.getCustomerSimpleList({ name: query });
        this.customerLoading = false;
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            const updateContent = this.formItem;
            if (this.openedDuizhangdan) {
              await this.updateDuizhangdan({
                id: this.openedDuizhangdan._id,
                data: updateContent,
              });
            } else {
              await this.createDuizhangdan(updateContent);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus"></style>
